<template>
  <div id="scanner" ref="scanner"></div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import Quagga from "@ericblade/quagga2";

const emit = defineEmits(["codeScanEvent"]);

const scannedCode = ref("");
const scanner = ref(null);

onMounted(() => {
  Quagga.init(
    {
      locate: true,
      inputStream: {
        name: "Live",
        type: "LiveStream",
        constraints: {
          width: 1920,
          height: 1080,
        },
        target: scanner.value,
        area: {
          top: "20%",
          right: "30%",
          left: "30%",
          bottom: "20%",
        },
      },
      decoder: {
        readers: ["code_39_reader"],
        multiple: false,
        debug: {
          drawBoundingBox: true,
          showFrequency: true,
          drawScanline: true,
          showPattern: true,
        },
      },
      locator: {
        halfSample: true,
        patchSize: "large",
        debug: {
          showCanvas: true,
          showPatches: true,
          showFoundPatches: true,
          showSkeleton: true,
          showLabels: true,
          showPatchLabels: true,
        },
      },
      debug: true
    },
    (err) => {
      if (err) {
        console.log(err);
        return;
      }
      Quagga.start();
    }
  );
  Quagga.onProcessed((data) => {
    if (data == null) return;
    if (typeof data != "object") return;
    if (data.boxes == undefined) return;
    const ctx = Quagga.canvas.ctx.overlay;
    const canvas = Quagga.canvas.dom.overlay;
    ctx.clearRect(0, 0, parseInt(canvas.width), parseInt(canvas.height));
    Quagga.ImageDebug.drawPath(data.box, { x: 0, y: 1 }, ctx, {
      color: "blue",
      lineWidth: 5,
    });
  });
  Quagga.onDetected((data) => {
    scannedCode.value = data.codeResult.code;
    emit("codeScanEvent", scannedCode.value);
  });
});

onBeforeUnmount(() => {
  Quagga.stop();
});
</script>

<style>
#scanner {
  height: 50vh;
  margin: 0 auto;
  padding: 0px;
  position: relative;
}

#scanner video {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}

#scanner canvas {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  margin-left: -50%;
}
</style>
